import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.displaysteuerung-rolle-berechtigung';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungDisplaysteuerungRolleBerechtigungEffects {

    DisplaysteuerungRolleBerechtigung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNG),
        mergeMap((x: ac.GetDisplaysteuerungRolleBerechtigungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDisplaysteuerungRolleBerechtigung(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetDisplaysteuerungRolleBerechtigungErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDisplaysteuerungRolleBerechtigungFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungQueryService);
        }
        return this.service;
    }
}
